import { REFERENCE_ATTACHMENT_TYPE } from './attachmentConstants';
import { isImageFile } from 'owa-file';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

const imageFileMimeTypes: string[] = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'];

export default function shouldPreviewImage(attachment: AttachmentType): boolean {
    return (
        isImageFile(attachment.Name) ||
        (attachment.__type !== REFERENCE_ATTACHMENT_TYPE && isImageMimeType(attachment.ContentType))
    );
}

function isImageMimeType(contentType: string): boolean {
    if (contentType) {
        return imageFileMimeTypes.indexOf(contentType.toLowerCase()) >= 0;
    }

    return false;
}
